export const APPO_ROUTES = {
    cupos: 'cupos-disponibles'
}